var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiplePagesDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16053 15.8332L5.92829 17.6009M2.39276 17.6009L4.16053 15.8332L2.39276 17.6009ZM5.92829 14.0654L4.16053 15.8332L5.92829 14.0654ZM4.16053 15.8332L2.39276 14.0654L4.16053 15.8332Z",
    stroke: "#130D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83331 1.66699H13.75L17.5 5.41699V15.8337",
    stroke: "#130D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 18.3337H13.75C14.4403 18.3337 15 17.774 15 17.0837V7.29077C15 7.15816 14.9473 7.03098 14.8536 6.93721L12.2297 4.31344C12.136 4.21967 12.0088 4.16699 11.8762 4.16699H3.75C3.05964 4.16699 2.5 4.72663 2.5 5.41699V10.8337",
    stroke: "#130D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 7.00033V4.46162C11.6667 4.2989 11.7986 4.16699 11.9614 4.16699C12.0394 4.16699 12.1144 4.19803 12.1697 4.25328L14.9137 6.99737C14.969 7.05262 15 7.12756 15 7.2057C15 7.36842 14.8681 7.50033 14.7054 7.50033H12.1667C11.8905 7.50033 11.6667 7.27647 11.6667 7.00033Z",
    fill: "#130D0D",
    stroke: "#130D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiplePagesDelete);
export default __webpack_public_path__ + "static/media/multiple-pages-delete.df7d9d5bde03caaf7c969737b0c4dc07.svg";
export { ForwardRef as ReactComponent };